export enum ToastId {
  FormSubmit = 'toastFormSubmit',
  AuthRedirect = 'toastAuthRedirect',
  NotificationStreamError = 'toastNotificationStreamError',
  AuthnError = 'toastAuthnError',
  AuthzError = 'toastAuthzError',
  VerifyUserSuccess = 'toastVerifyUserSuccess',
  VerifyUserFailure = 'toastVerifyUserFailure',
  ResetUserPasswordSuccess = 'toastResetUserPasswordSuccess',
  ResetUserPasswordFailure = 'toastResetUserPasswordFailure',
  UpdateUserRoleSuccess = 'toastUpdateUserRoleSuccess',
  UpdateUserRoleFailure = 'toastUpdateUserRoleFailure',
  UpdateUserSuccess = 'toastUpdateUserSuccess',
  UpdateUserFailure = 'toastUpdateUserFailure',
  PasswordResetRequestSuccess = 'toastPasswordResetRequestSuccess',
  PasswordResetRequestFailure = 'toastPasswordResetRequestFailure',
  UserRegisterSuccess = 'toastUserRegisterSuccess',
  UserRegisterFailure = 'toastUserRegisterFailure',
  CreateGlobalNotificationSuccess = 'toastCreateGlobalNotificationSuccess',
  CreateGlobalNotificationFailure = 'toastCreateGlobalNotificationFailure',
  CreatePersonalNotificationSuccess = 'toastCreatePersonalNotificationSuccess',
  CreatePersonalNotificationFailure = 'toastCreatePersonalNotificationFailure',
  NoticationAPIAccessDenied = 'toastNoticationAPIAccessDenied',
}
